export async function fetchIA(i: string, a: string) {
  const url = `https://213.97.35.99:5000/api/buda/ask-to-image/${i}/${a}`

  try {
    const data = await fetch(url)
    if (data.status === 200) {
      const json = await data.json()
      return json
    } else {
      return
    }
  } catch (e: any) {
    console.error('Error with IA server')
  }
}
